//import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"


export interface IListaDadosNotificacoes {
    codigo: number;
    codigo_Liga: number;    
    codigo_Usuario: number;    
    titulo: string;
    mensagem: string;     
    visualizado: boolean;
    tipo: number;   
    data_Visualizacao: Date;    
    codUsuCriacao: number;
    dtCriacao: Date;    

}

export interface IDadosRetornoNotificacoes {
    dado: IListaDadosNotificacoes[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosCadastroNotificacoes {
    //codigo: number;
    codigo_Liga: number;    
    codigo_Usuario: number;    
    titulo: string;
    mensagem: string;     
    visualizado: boolean;
    status: number;   
    data_Visualizacao: Date;    
    codUsuCriacao: number;
    dtCriacao: Date;    
}

const getAllDetalhesNotificacoes = async (): Promise<IDadosRetornoNotificacoes> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");    
    const { data } = await Api.get(`/mensagemnotificacao/usuario/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const Create = async (dados: IListaDadosCadastroNotificacoes): Promise<number | Error> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/mensagemnotificacao`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;
}

const updateById = async (codigo: number, dados: IListaDadosNotificacoes): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        await Api.put<IListaDadosNotificacoes>(`/mensagemnotificacao/${codigo}`, dados, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao atualizar o cidade");
    }

}

const updateVisualizarNotificacoes = async (): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        const user = CookieService.get("access_user");   
        await Api.put(`/mensagemnotificacao/visualizar/${user.codUsuario}`, null,{
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao atualizar o cidade");
    }

}



const deleteById = async (codigo: number, codigoUsuario: number): Promise<void | Error> => {
    try {
        const token = CookieService.get("access_token");
        await Api.delete(`/mensagemnotificacao/${codigo}/${codigoUsuario}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        });
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao excluir o arquivo");
    }
}



export const NotificacoesService = {
    getAllDetalhesNotificacoes,
    Create,
    updateById,
    deleteById,
    updateVisualizarNotificacoes
   
}